/**
 * Wishlist kept in the shopper's browser (localStorage), so it works without an account.
 *   [data-wishlist-toggle]  heart buttons (data-handle, data-title, data-url, data-image)
 *   [data-wishlist-count]   badges showing the number of saved pieces (hidden at 0)
 *   [data-wishlist-list]    list filled with saved pieces inside #wishlist-drawer
 *   [data-wishlist-empty]   message shown when nothing is saved
 *   [data-wishlist-open]    opens #wishlist-drawer, closing any open menu first
 *   [data-wishlist-root]    drawer body holding share settings (products URL, share URL, WhatsApp number, messages)
 *   [data-wishlist-qty]     quantity stepper on each saved piece (bin at 1 removes it); quantities go into the WhatsApp message
 *   Sharing: "Share my wishlist" builds ?wishlist=handle,handle links; opening one shows those pieces in the drawer.
 */
(function () {
  var KEY = 'anjani-wishlist';

  function read() {
    try {
      var items = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {}
    sync();
  }

  function has(items, handle) {
    for (var i = 0; i < items.length; i++) if (items[i].handle === handle) return i;
    return -1;
  }

  function qtyOf(item) {
    var q = parseInt(item.qty, 10);
    return q > 0 ? q : 1;
  }

  function paintStepper(stepper, qty) {
    var value = stepper.querySelector('[data-wishlist-qty-value]');
    if (value.textContent !== String(qty)) value.textContent = qty;
    var minus = stepper.querySelector('[data-wishlist-qty-minus]');
    minus.querySelector('[data-icon-trash]').hidden = qty > 1;
    minus.querySelector('[data-icon-minus]').hidden = qty <= 1;
    minus.setAttribute('aria-label', qty > 1 ? minus.dataset.labelDecrease : minus.dataset.labelRemove);
  }

  function syncButtons(items) {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    var filled = false;
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var at = has(items, b.dataset.handle);
      var on = at > -1;
      // Pieces saved before SKUs were stored pick theirs up from any heart on the page.
      if (on && !items[at].sku && b.dataset.sku) {
        items[at].sku = b.dataset.sku;
        filled = true;
      }
      // Same for the product number used by short share links.
      if (on && !items[at].id && b.dataset.id) {
        items[at].id = b.dataset.id;
        filled = true;
      }
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      var label = on ? b.dataset.labelRemove : b.dataset.labelAdd;
      if (label && b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
    }
    if (filled) {
      try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    }
  }

  function syncCounts(items) {
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = items.length;
      badges[i].hidden = items.length === 0;
    }
  }

  function syncList(items) {
    var list = document.querySelector('[data-wishlist-list]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!list) return;
    var showing = shared ? shared : items;
    if (empty) empty.hidden = shared ? true : items.length > 0;
    list.hidden = showing.length === 0;
    var tpl = document.getElementById('wishlist-item-template');
    list.textContent = '';
    syncShare(items);
    if (!tpl) return;
    showing.forEach(function (item) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var links = node.querySelectorAll('a');
      for (var i = 0; i < links.length; i++) links[i].href = item.url;
      var img = node.querySelector('img');
      if (img) {
        if (item.image) {
          img.src = item.image;
          img.alt = item.title;
        } else {
          img.remove();
        }
      }
      var title = node.querySelector('[data-wishlist-title]');
      if (title) title.textContent = item.title;
      var skuLine = node.querySelector('[data-wishlist-sku]');
      if (skuLine) {
        if (shared) {
          // Always show the SKU row in shared lists; a dash marks a product with no SKU yet.
          skuLine.querySelector('[data-wishlist-sku-value]').textContent = item.sku || '—';
          skuLine.hidden = false;
        } else {
          skuLine.remove();
        }
      }
      var stepper = node.querySelector('[data-wishlist-qty]');
      var fixed = node.querySelector('[data-wishlist-qty-static]');
      if (shared) {
        if (stepper) stepper.remove();
        if (fixed) {
          fixed.hidden = false;
          fixed.querySelector('[data-wishlist-qty-static-value]').textContent = qtyOf(item);
        }
      } else {
        if (fixed) fixed.remove();
        if (stepper) {
          stepper.dataset.handle = item.handle;
          paintStepper(stepper, qtyOf(item));
        }
      }
      var toggle = node.querySelector('[data-wishlist-toggle]');
      if (toggle) {
        toggle.dataset.handle = item.handle;
        toggle.dataset.title = item.title;
        toggle.dataset.url = item.url;
        toggle.dataset.image = item.image || '';
        toggle.dataset.sku = item.sku || '';
        toggle.dataset.id = item.id || '';
        toggle.setAttribute('aria-pressed', String(has(items, item.handle) > -1));
      }
      list.appendChild(node);
    });
  }

  /* ---- Sharing --------------------------------------------------------- */
  var shared = null; // array of items when viewing a shared wishlist

  function root() {
    return document.querySelector('[data-wishlist-root]');
  }

  // Product numbers in links: (id - ID_BASE) in base 62, about 7 characters. Never change ID_BASE, or older links break.
  var ID_BASE = 8140000000000;
  var B62 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  function toCode(id) {
    var n = Number(id) - ID_BASE;
    if (!(n > 0)) return '~' + Number(id).toString(36); // outside the range: plain base 36 after "~"
    var s = '';
    while (n > 0) { s = B62[n % 62] + s; n = Math.floor(n / 62); }
    return s;
  }
  function fromCode(code) {
    if (code.charAt(0) === '~') return parseInt(code.slice(1), 36) || 0;
    var n = 0;
    for (var i = 0; i < code.length; i++) {
      var d = B62.indexOf(code.charAt(i));
      if (d < 0) return 0;
      n = n * 62 + d;
    }
    return n > 0 ? n + ID_BASE : 0;
  }
  // Country travels as its 2-letter code (India -> IN) and is shown as the name again.
  var regionNames = null;
  function regions() {
    if (regionNames === null) {
      try { regionNames = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) { regionNames = false; }
    }
    return regionNames;
  }
  var codeByName = null;
  function countryCode(name) {
    var r = regions();
    if (!r || !name) return '';
    if (!codeByName) {
      codeByName = {};
      var A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      for (var i = 0; i < 26; i++) for (var j = 0; j < 26; j++) {
        var c = A[i] + A[j];
        try { var n = r.of(c); if (n && n !== c) codeByName[n.toLowerCase()] = c; } catch (e) {}
      }
    }
    var code = codeByName[name.toLowerCase()];
    // Only use the code when it reads back as the same name, so the opener sees exactly what was chosen.
    return code && r.of(code) === name ? code : '';
  }
  function countryName(code) {
    var r = regions();
    if (!r || !/^[A-Z]{2}$/.test(code)) return code;
    try { return r.of(code) || code; } catch (e) { return code; }
  }

  /* ---- Shortest links: ?r= positions in the live catalogue ----
   * The catalogue is every product on /collections/all, sorted by product number. New products get
   * higher numbers, so adding products never moves existing positions. Removing or hiding one does,
   * so the link starts with a 2-character check of the chosen product numbers; a mismatch shows
   * "out of date" instead of wrong designs. Positions are stored as gaps from the previous one:
   * one character for gaps under 31, two under 961. */
  var CATALOG = null; // { ids: [sorted numbers as strings], map: { id: handle } }
  var catalogLoading = null;
  function catalog(fresh) {
    if (!fresh && CATALOG) return Promise.resolve(CATALOG);
    if (!fresh) {
      try {
        var cached = JSON.parse(localStorage.getItem(INDEX_KEY + '-full') || 'null');
        if (cached && Date.now() - cached.t < 36e5 && cached.map) {
          CATALOG = { ids: sortIds(cached.map), map: cached.map };
          return Promise.resolve(CATALOG);
        }
      } catch (e) {}
    }
    if (catalogLoading && !fresh) return catalogLoading;
    var r = root();
    var products = (r && r.dataset.productsUrl) || '/products/';
    var url = products.replace(/products\/?$/, '') + 'collections/all?view=wl-index&page=';
    var map = {};
    var failed = false;
    function batch(start) {
      var pages = [];
      for (var n = start; n < start + 6; n++) pages.push(n);
      return Promise.all(pages.map(function (n) {
        return fetch(url + n, { credentials: 'same-origin' })
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })).then(function (results) {
        var more = true;
        results.forEach(function (data) {
          if (!data || !data.p) { failed = failed || more; more = false; return; }
          Object.keys(data.p).forEach(function (id) { map[id] = data.p[id]; });
          if (!data.next) more = false;
        });
        if (more && start < 55) return batch(start + 6);
      });
    }
    catalogLoading = batch(1).then(function () {
      catalogLoading = null;
      if (failed || !Object.keys(map).length) return null;
      CATALOG = { ids: sortIds(map), map: map };
      try { localStorage.setItem(INDEX_KEY + '-full', JSON.stringify({ t: Date.now(), map: map })); } catch (e) {}
      return CATALOG;
    });
    return catalogLoading;
  }
  function sortIds(map) {
    return Object.keys(map).sort(function (a, b) { return Number(a) - Number(b); });
  }
  function putNum(n) {
    var digits = [];
    do { digits.unshift(n % 31); n = Math.floor(n / 31); } while (n > 0);
    return digits.map(function (d, i) { return B62[i < digits.length - 1 ? d + 31 : d]; }).join('');
  }
  function takeNums(s) {
    var out = [], n = 0;
    for (var i = 0; i < s.length; i++) {
      var d = B62.indexOf(s.charAt(i));
      if (d < 0) return null;
      if (d >= 31) { n = n * 31 + (d - 31); } else { out.push(n * 31 + d); n = 0; }
    }
    return out;
  }
  function checkOf(ids) {
    var h = 2166136261;
    var s = ids.join(',');
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    h = h % 3844;
    return B62[Math.floor(h / 62)] + B62[h % 62];
  }
  function rankLink(items) {
    if (!CATALOG) return '';
    var pos = {};
    CATALOG.ids.forEach(function (id, i) { pos[id] = i; });
    var picked = [];
    for (var i = 0; i < items.length; i++) {
      var at = pos[String(items[i].id || '')];
      if (at === undefined) return '';
      picked.push({ at: at, id: String(items[i].id), qty: qtyOf(items[i]) });
    }
    picked.sort(function (a, b) { return a.at - b.at; });
    picked = picked.filter(function (p, i) { return !i || p.at !== picked[i - 1].at; });
    var prev = -1;
    var gaps = picked.map(function (p) { var g = putNum(p.at - prev - 1); prev = p.at; return g; }).join('');
    var link = '?r=' + checkOf(picked.map(function (p) { return p.id; })) + gaps;
    if (picked.some(function (p) { return p.qty > 1; })) {
      link += '&q=' + picked.map(function (p) { return putNum(p.qty - 1); }).join('');
    }
    return link;
  }

  function shareUrl(items) {
    var r = root();
    var base = (r && r.dataset.shareUrl) || location.origin + '/';
    var saved = readLocation();
    var ranked = rankLink(items);
    if (ranked) {
      var where = ['city', 'state', 'country'].map(function (key) {
        var v = (saved[key] || '').trim();
        if (key === 'country') v = countryCode(v) || v;
        return encodeURIComponent(v.replace(/~/g, '-')).replace(/%20/g, '+');
      });
      // &t= share time: seconds since 1 Jan 2026 in base 62 (5 characters).
      var secs = Math.max(0, Math.floor((Date.now() - T_BASE) / 1000));
      var t = '';
      do { t = B62[secs % 62] + t; secs = Math.floor(secs / 62); } while (secs > 0);
      return base.replace(/^https?:\/\//, '') + ranked + (where.join('') ? '&l=' + where.join('~') : '') + '&t=' + t;
    }
    // Short link: ?w=<product number in base 36>[.qty],... and &l=City~State~Country.
    // The opener looks the numbers up (collection.wl-index template), so handles and SKUs stay out of the link.
    var allIds = items.length && items.every(function (item) { return /^\d+$/.test(String(item.id || '')); });
    if (allIds) {
      var codes = items.map(function (item) {
        var qty = qtyOf(item);
        var code = toCode(item.id);
        return qty > 1 ? code + '.' + qty : code;
      }).join(',');
      // No "https://": WhatsApp and browsers still open "anjaniart.com/?p=...".
      var short = base.replace(/^https?:\/\//, '') + '?p=' + codes;
      var loc = ['city', 'state', 'country'].map(function (key) {
        var v = (saved[key] || '').trim();
        if (key === 'country') v = countryCode(v) || v;
        return encodeURIComponent(v.replace(/~/g, '-')).replace(/%20/g, '+');
      });
      if (loc.join('')) short += '&l=' + loc.join('~');
      return short;
    }
    // Fallback (a piece with no product number yet): the older long link.
    // Each piece is "handle" or "handle:qty" when more than one is wanted.
    var handles = items.map(function (item) {
      var qty = qtyOf(item);
      if (item.sku) return item.handle + ':' + qty + ':' + encodeURIComponent(item.sku);
      return qty > 1 ? item.handle + ':' + qty : item.handle;
    }).join(',');
    var url = base + '?wishlist=' + encodeURIComponent(handles).replace(/%2C/g, ',').replace(/%3A/gi, ':');
    // The buyer's location travels with the link so whoever opens it sees it too.
    ['country', 'state', 'city'].forEach(function (key) {
      var v = (saved[key] || '').trim();
      if (v) url += '&' + key + '=' + encodeURIComponent(v).replace(/%20/g, '+');
    });
    return url;
  }

  // Location from an opened shared link: { country, state, city }.
  var sharedLocation = {};
  // Share time from &t=, shown under the "Shared wishlist" title in India time: 26-10-2026, 13:12:05.
  var T_BASE = Date.UTC(2026, 0, 1);
  var sharedTime = null;
  function readSharedTime(code) {
    if (!code || code.length > 8) return null;
    var n = 0;
    for (var i = 0; i < code.length; i++) {
      var d = B62.indexOf(code.charAt(i));
      if (d < 0) return null;
      n = n * 62 + d;
    }
    return new Date(T_BASE + n * 1000);
  }
  function paintSharedTime() {
    var line = document.querySelector('[data-wishlist-shared-time]');
    if (!line) return;
    var text = '';
    if (shared !== null && sharedTime) {
      try {
        var parts = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
          .formatToParts(sharedTime).forEach(function (p) { parts[p.type] = p.value; });
        text = parts.day + '-' + parts.month + '-' + parts.year + ', ' + parts.hour + ':' + parts.minute + ':' + parts.second;
      } catch (e) {}
    }
    if (line.textContent !== text) line.textContent = text;
    line.hidden = !text;
  }

  function paintSharedLocation() {
    paintSharedTime();
    var box = document.querySelector('[data-wishlist-shared-location]');
    if (!box) return;
    var any = false;
    ['country', 'state', 'city'].forEach(function (key) {
      var cell = document.querySelector('[data-wishlist-shared-loc="' + key + '"]');
      var v = sharedLocation[key] || '';
      if (v) any = true;
      if (cell) cell.textContent = niceName(v) || "—";
    });
    box.hidden = !(shared !== null && any);
  }

  /* ---- Buyer location (country → state → city) for the WhatsApp message ----
   * Country and state options come from Shopify's country data rendered in Liquid
   * (each country <option> carries its states in data-provinces). City suggestions
   * load from a public city directory into a <datalist>; the city field always
   * accepts typed text, so the share never depends on that directory. */
  var LOC_KEY = 'anjani-wishlist-location';
  var LOC_FIELDS = ['city', 'state', 'country'];
  var CITY_API = 'https://countriesnow.space/api/v0.1/countries/state/cities/q';
  var cityCache = {};
  var cityRequest = 0;

  function readLocation() {
    try {
      return JSON.parse(localStorage.getItem(LOC_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeLocation(saved) {
    try {
      localStorage.setItem(LOC_KEY, JSON.stringify(saved));
    } catch (e) {}
  }

  function locField(key) {
    return document.querySelector('[data-wishlist-loc="' + key + '"]');
  }

  function locationInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-wishlist-loc]'));
  }

  function statesFor(country) {
    var select = document.querySelector('[data-wishlist-provinces]');
    if (!select || !country) return [];
    var option = Array.prototype.find.call(select.options, function (o) { return o.value === country; });
    if (!option || !option.dataset.provinces) return [];
    try {
      return JSON.parse(option.dataset.provinces).map(function (pair) { return pair[1] || pair[0]; });
    } catch (e) {
      return [];
    }
  }

  var STATES_API = 'https://countriesnow.space/api/v0.1/countries/states/q';
  var stateCache = {};
  var stateRequest = 0;

  // Tidy place names from the city/state directory: trim, single spaces, Proper Case when the
  // source is all caps or all lower case, and sorted A-Z without duplicates.
  function niceName(name) {
    var s = String(name || '').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    if (s === s.toUpperCase() || s === s.toLowerCase()) {
      s = s.toLowerCase().replace(/(^|[\s\-(\/.])([a-z\u00e0-\u00ff])/g, function (m, p, c) { return p + c.toUpperCase(); });
    }
    return s;
  }
  // The directory often lists a city twice: an accented spelling (Ahmadābād) and the everyday
  // English one (Ahmedabad), or with a space/hyphen/double-letter difference (Raj Nandgaon,
  // Raj-Nandgaon; Kovur, Kovvur). It also tags some names "District" or "(India)" and has a few
  // comma-joined entries. Clean names, keep one of each, and show accented names without marks.
  // Older or alternate spellings the directory lists beside the common name.
  var CITY_ALIASES = {
    'mahesana': 'Mehsana', 'dohad': 'Dahod', 'bid': 'Beed', 'gondiya': 'Gondia',
    'vishakhapatnam': 'Visakhapatnam', 'monghyr': 'Munger', 'saugor': 'Sagar',
    'dhulia': 'Dhule', 'hazaribag': 'Hazaribagh', 'davangere': 'Davanagere', 'bellary': 'Ballari',
    'madhipura': 'Madhepura', 'dhuburi': 'Dhubri', 'khambhaliya': 'Khambhalia',
    'vallabhipur': 'Valabhipur', 'chik ballapur': 'Chikkaballapur', 'pattanamtitta': 'Pathanamthitta',
    'bandipura': 'Bandipore', 'siddhapur': 'Siddhpur', 'bagasra': 'Bagasara', 'vansada': 'Vansda'
  };
  function plain(s) { return s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function skeleton(s) { return plain(s).toLowerCase().replace(/[^a-z]/g, '').replace(/[aeiou]/g, 'a'); }
  function tightKey(s) { return plain(s).toLowerCase().replace(/[^a-z0-9]/g, '').replace(/(.)\1+/g, '$1'); }
  function niceList(list) {
    var names = (list || []).map(niceName).filter(function (n) { return n && n.indexOf(',') === -1; }).map(function (n) {
      var t = n.replace(/\s*\((India|[^)]*-Dist\.?)\)$/i, '').replace(/\s+(District|Dist\.?)$/i, '').trim();
      // Keep Sikkim-style "East District": a lone direction is not a place name.
      t = /^(North|South|East|West|Central)$/i.test(t) ? n : t;
      return CITY_ALIASES[t.toLowerCase()] || t;
    }).filter(function (n) { return n && !/\(historical\)$/i.test(n); });
    var plainKeys = {};
    names.forEach(function (n) { if (plain(n) === n) plainKeys[skeleton(n)] = true; });
    var seen = {};
    return names.filter(function (n) {
      return plain(n) === n || !plainKeys[skeleton(n)];
    }).map(plain).filter(function (n) {
      var k = tightKey(n);
      if (seen[k]) return false;
      seen[k] = true;
      return true;
    }).sort(function (a, b) { return a.localeCompare(b, undefined, { sensitivity: 'base' }); });
  }

  function getJSON(url, params) {
    return fetch(url + '?' + new URLSearchParams(params).toString())
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function paintStates(select, states, emptyText, selected) {
    var first = document.createElement('option');
    first.value = '';
    first.textContent = emptyText;
    select.replaceChildren(first);
    states.forEach(function (name) {
      var option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      select.appendChild(option);
    });
    select.disabled = states.length === 0;
    select.required = states.length > 0;
    select.value = states.indexOf(selected) > -1 ? selected : '';
  }

  // Shopify only lists states for countries whose checkout needs them, so other
  // countries load their states from the same public directory used for cities.
  function fillStates(country, selected) {
    var select = locField('state');
    if (!select) return;
    var request = ++stateRequest;
    if (!country) return paintStates(select, [], select.dataset.placeholder, '');
    var states = statesFor(country);
    if (states.length) return paintStates(select, states, select.dataset.placeholder, selected);
    if (stateCache[country]) {
      var cached = stateCache[country];
      return paintStates(select, cached, cached.length ? select.dataset.placeholder : select.dataset.none, selected);
    }
    paintStates(select, [], select.dataset.loading || select.dataset.placeholder, '');
    getJSON(STATES_API, { country: country }).then(function (json) {
      var list = niceList(json && json.data && Array.isArray(json.data.states) ? json.data.states.map(function (s) { return s.name; }) : []);
      if (list.length || json) stateCache[country] = list;
      if (request !== stateRequest) return;
      paintStates(select, list, list.length ? select.dataset.placeholder : select.dataset.none, selected);
      if (selected && list.indexOf(selected) > -1) fillCities(country, selected);
    });
  }

  function citySelect() {
    return document.querySelector('[data-wishlist-city-select]');
  }

  // Show the city dropdown, or the typed city box when the directory has no list
  // for this state or the buyer picks "Other".
  function showCityBox(show) {
    var input = locField('city');
    if (!input) return;
    input.hidden = !show;
    input.required = show;
  }

  function paintCitySelect(select, cities, emptyText, disabled) {
    var saved = readLocation();
    var first = document.createElement('option');
    first.value = '';
    first.textContent = emptyText;
    var fragment = document.createDocumentFragment();
    fragment.appendChild(first);
    cities.forEach(function (name) {
      var option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      fragment.appendChild(option);
    });
    if (cities.length) {
      var other = document.createElement('option');
      other.value = '__other';
      other.textContent = select.dataset.other || 'Other';
      fragment.appendChild(other);
    }
    select.replaceChildren(fragment);
    select.disabled = disabled;
    var city = (saved.city || '').trim();
    if (!cities.length || !city) {
      select.value = '';
      showCityBox(false);
    } else if (cities.indexOf(city) > -1) {
      select.value = city;
      showCityBox(false);
    } else {
      select.value = '__other';
      showCityBox(true);
    }
  }

  function fillCities(country, state) {
    var select = citySelect();
    if (!select) return;
    select.hidden = false;
    var request = ++cityRequest;
    if (!country || !state) {
      paintCitySelect(select, [], select.dataset.placeholder, true);
      return;
    }
    var cacheKey = country + '|' + state;
    var paint = function (cities) {
      if (request !== cityRequest) return;
      if (!cities.length) {
        // No list for this state: let the buyer type the city instead.
        select.hidden = true;
        select.disabled = true;
        showCityBox(true);
        return;
      }
      paintCitySelect(select, cities, select.dataset.placeholder, false);
    };
    if (cityCache[cacheKey]) return paint(cityCache[cacheKey]);
    paintCitySelect(select, [], select.dataset.loading || select.dataset.placeholder, true);
    var citiesFrom = function (json) {
      var list = json && Array.isArray(json.data) ? json.data : [];
      return niceList(list);
    };
    // Try the state name as shown first, then without a trailing "State/Province/Region/District/County".
    getJSON(CITY_API, { country: country, state: state }).then(function (json) {
      var cities = citiesFrom(json);
      var short = state.replace(/ (State|Province|Region|District|County|Emirate)$/i, '');
      if (cities.length || short === state) return cities;
      return getJSON(CITY_API, { country: country, state: short }).then(citiesFrom);
    }).then(function (cities) {
      // Only remember real lists, so a busy or failed lookup is retried next time.
      if (cities.length) cityCache[cacheKey] = cities;
      paint(cities);
    });
  }

  /* Fill country, state and city from the buyer's approximate location (from their internet connection,
   * via BigDataCloud's free browser lookup: no permission prompt, no key). Runs once per browser, only
   * while no state has been chosen, and never overwrites anything the buyer picked themselves. */
  var GEO_API = 'https://api.bigdatacloud.net/data/reverse-geocode-client?localityLanguage=en';
  var GEO_KEY = 'anjani-wishlist-located';
  var locating = false;
  function autoLocate() {
    if (locating) return;
    var saved = readLocation();
    if (saved.state) return;
    try { if (localStorage.getItem(GEO_KEY)) return; } catch (e) { return; }
    locating = true;
    var started = JSON.stringify(saved);
    // Shared lookup from the layout head (also used by the footer country and Currency Rate); own request as a fallback.
    var lookup = typeof window.anjaniGeo === 'function'
      ? window.anjaniGeo()
      : fetch(GEO_API, { credentials: 'omit' }).then(function (res) { return res.ok ? res.json() : null; });
    Promise.resolve(lookup)
      .catch(function () { return null; })
      .then(function (geo) {
        locating = false;
        if (!geo) return; // try again on a later visit
        try { localStorage.setItem(GEO_KEY, String(Date.now())); } catch (e) {}
        var country = locField('country');
        if (!country) return;
        // The buyer changed something while we waited: leave their choice alone.
        if (JSON.stringify(readLocation()) !== started) return;
        var options = Array.prototype.map.call(country.options, function (o) { return o.value; });
        var match = function (name) {
          if (!name) return '';
          var lower = name.toLowerCase();
          for (var i = 0; i < options.length; i++) if (options[i] && options[i].toLowerCase() === lower) return options[i];
          return '';
        };
        var countryName = match(countryName2(geo.countryCode)) || match(geo.countryName);
        if (!countryName) return; // not a country we ship to from the footer list
        var next = readLocation();
        if (next.country && next.country !== countryName) return; // a different country is already chosen
        next.country = countryName;
        next.state = (geo.principalSubdivision || '').trim();
        next.city = (geo.city || geo.locality || '').trim();
        writeLocation(next);
        country.value = countryName;
        fillStates(countryName, next.state);
        var stateField = locField('state');
        // States from Shopify's list fill straight away; if the detected one is not on it, keep only the country.
        if (stateField && stateField.options.length > 1 && stateField.value !== next.state) {
          next.state = '';
          next.city = '';
          writeLocation(next);
        }
        fillCities(countryName, next.state);
        sync();
      });
  }
  function countryName2(code) {
    return /^[A-Z]{2}$/.test(code || '') ? countryName(code) : '';
  }

  var locationPainted = false;
  function paintLocation() {
    var saved = readLocation();
    var country = locField('country');
    var state = locField('state');
    var city = locField('city');
    if (!country) return;
    if (!locationPainted) {
      locationPainted = true;
      // No saved country yet: start from the visitor's country shown in the footer
      // (Shopify's detected or chosen country), so most buyers only pick state and city.
      if (!saved.country) {
        var footerCountry = document.querySelector('[data-current-country-name]');
        var r = root();
        var detected = (footerCountry && footerCountry.textContent.trim()) || (r && r.dataset.defaultCountry) || '';
        if (detected && Array.prototype.some.call(country.options, function (o) { return o.value === detected; })) {
          saved.country = detected;
          saved.state = '';
          saved.city = '';
          writeLocation(saved);
        }
      }
      country.value = saved.country || '';
      if (country.value !== (saved.country || '')) country.value = '';
      fillStates(country.value, saved.state || '');
      fillCities(country.value, state ? state.value : '');
      autoLocate();
    }
    if (city && document.activeElement !== city && city.value !== (saved.city || '')) city.value = saved.city || '';
  }

  function locationText() {
    var saved = readLocation();
    return LOC_FIELDS.map(function (key) { return (saved[key] || '').trim(); }).filter(Boolean).join(', ');
  }

  function firstMissingLocation() {
    var saved = readLocation();
    var missing = locationInputs().find(function (input) {
      if (input.disabled) return false; // country has no states
      return !(saved[input.dataset.wishlistLoc] || '').trim();
    }) || null;
    // A hidden city box means the buyer still has to pick from the city dropdown.
    if (missing && missing.hidden) {
      var picker = citySelect();
      if (picker && !picker.hidden) return picker;
    }
    return missing;
  }

  function updateLocation(input) {
    var key = input.dataset.wishlistLoc;
    var saved = readLocation();
    saved[key] = input.value;
    if (key === 'country') {
      saved.state = '';
      saved.city = '';
      fillStates(input.value, '');
      var cityField = locField('city');
      if (cityField) cityField.value = '';
      fillCities('', '');
    } else if (key === 'state') {
      saved.city = '';
      var cityInput = locField('city');
      if (cityInput) cityInput.value = '';
      fillCities(saved.country || '', input.value);
    }
    writeLocation(saved);
  }


  function syncShare(items) {
    paintLocation();
    var r = root();
    if (!r) return;
    var box = r.querySelector('[data-wishlist-share]');
    var note = r.querySelector('[data-wishlist-shared-note]');
    var heading = document.getElementById('wishlist-drawer-title');
    if (box) box.hidden = shared !== null || items.length === 0;
    var shareTop = document.querySelector('[data-wishlist-share-top]');
    if (shareTop) shareTop.hidden = shared !== null || items.length === 0;
    if (shared !== null || items.length === 0) setStatus('');
    if (note) note.hidden = shared === null;
    paintSharedLocation();
    if (heading && heading.dataset.titleOwn) {
      var text = shared ? heading.dataset.titleShared : heading.dataset.titleOwn;
      if (heading.textContent !== text) heading.textContent = text;
    }
    var wa = document.querySelector('[data-wishlist-whatsapp]');
    if (wa && items.length) {
      var qtyLabel = r.dataset.qtyLabel || 'Qty';
      var lines = items.map(function (item) { return '- ' + item.title + ' (' + qtyLabel + ' ' + qtyOf(item) + ')'; }).join('\n');
      var place = locationText();
      var locLine = place ? '\n' + (r.dataset.locationLabel || 'Location') + ': ' + place : '';
      var message = (r.dataset.message || '').replace('[count]', items.length) + '\n' + lines + locLine + '\n' + shareUrl(items);
      wa.href = 'https://wa.me/' + (r.dataset.whatsapp || '') + '?text=' + encodeURIComponent(message);
    }
  }

  function setStatus(text) {
    var status = document.querySelector('[data-wishlist-share-status]');
    if (status) status.textContent = text || '';
  }

  function shareLink() {
    var r = root();
    var items = read();
    if (!items.length) return;
    var url = shareUrl(items);
    var title = (r && r.dataset.shareTitle) || document.title;
    if (navigator.share) {
      // Sent as text: the link has no "https://" and a share "url" would be read as a page on this site.
      navigator.share({ text: url }).catch(function () {});
      return;
    }
    var done = function () { setStatus(r && r.dataset.copied); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt(title, url); });
    } else {
      window.prompt(title, url);
    }
  }

  function setSharedText(state) {
    var p = document.querySelector('[data-shared-text]');
    if (p && state in p.dataset) p.textContent = p.dataset[state];
    // Hide the shared note's frame when there is neither a message nor a location to show.
    var note = document.querySelector('[data-wishlist-shared-note]');
    if (note) note.classList.toggle('hidden', !(p && p.textContent));
  }

  function openDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (drawer && !drawer.open) {
      try { drawer.showModal(); } catch (e) {}
    }
  }

  // Product number -> handle for short links, read page by page from the hidden lookup and kept for 6 hours.
  var INDEX_KEY = 'anjani-wishlist-index';
  function productIndex(ids) {
    try {
      var cached = JSON.parse(localStorage.getItem(INDEX_KEY) || 'null');
      if (cached && Date.now() - cached.t < 216e5 && ids.every(function (id) { return cached.p[id]; })) {
        return Promise.resolve(cached.p);
      }
    } catch (e) {}
    var r = root();
    var products = (r && r.dataset.productsUrl) || '/products/';
    var url = products.replace(/products\/?$/, '') + 'collections/all?view=wl-index&page=';
    var map = {};
    function batch(start) {
      var pages = [];
      for (var n = start; n < start + 6; n++) pages.push(n);
      return Promise.all(pages.map(function (n) {
        return fetch(url + n, { credentials: 'same-origin' })
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })).then(function (results) {
        var more = results.length > 0;
        results.forEach(function (data) {
          if (!data || !data.p) { more = false; return; }
          Object.keys(data.p).forEach(function (id) { map[id] = data.p[id]; });
          if (!data.next) more = false;
        });
        // Stop early once every wanted piece is found, or after 60 pages (3,000 products).
        var found = ids.every(function (id) { return map[id]; });
        if (more && !found && start < 55) return batch(start + 6);
      });
    }
    return batch(1).then(function () {
      try { localStorage.setItem(INDEX_KEY, JSON.stringify({ t: Date.now(), p: map })); } catch (e) {}
      return map;
    });
  }

  function loadShared() {
    var params = new URLSearchParams(location.search);
    // ?p= base 62 codes (current), ?w= base 36 numbers (first short links), ?wishlist= handles (oldest).
    var p62 = params.get('p');
    var short = p62 || params.get('w');
    var rk = params.get('r');
    var raw = params.get('wishlist');
    if (!raw && !short && !rk) return;
    sharedLocation = {};
    sharedTime = readSharedTime(params.get('t'));
    if (short || rk) {
      var loc = (params.get('l') || '').split('~');
      sharedLocation.city = (loc[0] || '').trim().slice(0, 80);
      sharedLocation.state = (loc[1] || '').trim().slice(0, 80);
      sharedLocation.country = countryName((loc[2] || '').trim()).slice(0, 80);
    } else {
      ['country', 'state', 'city'].forEach(function (key) {
        sharedLocation[key] = (params.get(key) || '').trim().slice(0, 80);
      });
      // Links from before 26 Oct 2026 carried one "City, State, Country" value.
      var combined = (params.get('location') || '').trim();
      if (combined && !sharedLocation.country) {
        var parts = combined.split(',').map(function (s) { return s.trim(); });
        sharedLocation.country = (parts.pop() || '').slice(0, 80);
        sharedLocation.state = (parts.pop() || '').slice(0, 80);
        sharedLocation.city = parts.join(', ').slice(0, 80);
      }
    }
    var qtys = {};
    var linkSkus = {};
    var handlesReady;
    var stale = false;
    if (rk) {
      var check = rk.slice(0, 2);
      var gaps = takeNums(rk.slice(2)) || [];
      var qlist = takeNums(params.get('q') || '') || [];
      if (!gaps.length) return;
      var decode = function (cat) {
        if (!cat) return null;
        var at = -1;
        var ids = gaps.slice(0, 60).map(function (g) { at += g + 1; return cat.ids[at]; });
        if (ids.some(function (id) { return !id; }) || checkOf(ids) !== check) return null;
        return ids.map(function (id, i) {
          var handle = cat.map[id];
          qtys[handle] = Math.min((qlist[i] || 0) + 1, 999);
          return handle;
        });
      };
      // Try the saved catalogue first; if it does not match, load it fresh once before calling the link out of date.
      handlesReady = catalog(false).then(function (cat) {
        return decode(cat) || catalog(true).then(function (freshCat) {
          var handles = decode(freshCat);
          if (!handles) stale = true;
          return handles || [];
        });
      });
    } else if (short) {
      // Short link pieces: "<base 36 number>" or "<base 36 number>.<qty>".
      var wanted = short.split(',').map(function (part) {
        var bits = part.trim().split('.');
        var id = p62 ? fromCode(bits[0]) : parseInt(bits[0], 36);
        var q = parseInt(bits[1], 10);
        return id > 0 ? { id: String(id), qty: q > 0 ? Math.min(q, 999) : 1 } : null;
      }).filter(Boolean).slice(0, 60);
      if (!wanted.length) return;
      handlesReady = productIndex(wanted.map(function (w) { return w.id; })).then(function (map) {
        return wanted.map(function (w) {
          var handle = map[w.id];
          if (handle) qtys[handle] = w.qty;
          return handle;
        }).filter(Boolean);
      });
    } else {
      var handles = raw.split(',').map(function (part) {
        var bits = part.trim().split(':');
        var q = parseInt(bits[1], 10);
        if (bits[0]) qtys[bits[0]] = q > 0 ? Math.min(q, 999) : 1;
        // Optional third part: the SKU, sent in the link so it shows even without product data.
        if (bits[0] && bits.length > 2) {
          try { linkSkus[bits[0]] = decodeURIComponent(bits.slice(2).join(':')).slice(0, 60); } catch (e) {}
        }
        return bits[0];
      }).filter(Boolean).slice(0, 60);
      if (!handles.length) return;
      handlesReady = Promise.resolve(handles);
    }
    var r = root();
    var base = (r && r.dataset.productsUrl) || '/products/';
    shared = [];
    sync();
    setSharedText('loading');
    openDrawer();
    handlesReady.then(function (handles) {
      return Promise.all(handles.map(function (handle) {
        return fetch(base + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      }));
    }).then(function (products) {
      shared = products.filter(Boolean).map(function (p) {
        var image = p.featured_image || (p.images && p.images[0]) || '';
        if (image && image.indexOf('//') === 0) image = 'https:' + image;
        var skus = (p.variants || []).map(function (v) { return (v.sku || '').trim(); })
          .filter(function (s, i, all) { return s && all.indexOf(s) === i; });
        return { handle: p.handle, title: p.title, url: p.url || base + p.handle, image: image, qty: qtys[p.handle] || 1, sku: linkSkus[p.handle] || skus.join(', '), id: String(p.id || '') };
      });
      setSharedText(shared.length ? 'ready' : stale ? 'stale' : 'none');
      sync();
    });
  }

  // Pieces saved before product numbers were stored look theirs up once, so share links can be short.
  function fillIds() {
    var items = read();
    var missing = items.filter(function (item) { return !item.id && item.handle; }).slice(0, 60);
    if (!missing.length) return;
    var r = root();
    var base = (r && r.dataset.productsUrl) || '/products/';
    Promise.all(missing.map(function (item) {
      return fetch(base + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (p) { return p && p.id ? [item.handle, String(p.id)] : null; })
        .catch(function () { return null; });
    })).then(function (pairs) {
      var latest = read();
      var changed = false;
      pairs.filter(Boolean).forEach(function (pair) {
        var at = has(latest, pair[0]);
        if (at > -1 && !latest[at].id) { latest[at].id = pair[1]; changed = true; }
      });
      if (changed) write(latest);
    });
  }

  function leaveShared() {
    shared = null;
    try {
      var url = new URL(location.href);
      url.searchParams.delete('wishlist');
      url.searchParams.delete('w');
      url.searchParams.delete('p');
      ['l', 'r', 'q', 't'].forEach(function (key) { url.searchParams.delete(key); });
      ['location', 'country', 'state', 'city'].forEach(function (key) { url.searchParams.delete(key); });
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    } catch (e) {}
    sync();
  }

  var syncing = false;
  function sync() {
    if (syncing) return;
    syncing = true;
    var items = read();
    // Load the catalogue once someone has saved pieces, so their share link can use the shortest form.
    if (items.length && !CATALOG && !catalogLoading) {
      catalog(false).then(function (cat) { if (cat) sync(); });
    }
    syncList(items);
    syncButtons(items);
    syncCounts(items);
    syncing = false;
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-wishlist-qty-minus], [data-wishlist-qty-plus]');
    if (step) {
      event.preventDefault();
      event.stopPropagation();
      var box = step.closest('[data-wishlist-qty]');
      var list = read();
      var at = box ? has(list, box.dataset.handle) : -1;
      if (at === -1) return;
      var current = qtyOf(list[at]);
      var plus = step.hasAttribute('data-wishlist-qty-plus');
      if (!plus && current <= 1) {
        // Bin: remove the piece and redraw the list.
        list.splice(at, 1);
        write(list);
        return;
      }
      // Quantity change: update only this stepper and the share message, so taps feel instant.
      var next = plus ? Math.min(current + 1, 999) : current - 1;
      list[at].qty = next;
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
      paintStepper(box, next);
      syncShare(list);
      return;
    }
    // Purchase Single: save this piece (never remove it), show the buyer's own list, then open the drawer.
    var purchase = event.target.closest('[data-wishlist-purchase]');
    if (purchase) {
      event.preventDefault();
      var scope = purchase.parentElement;
      var heart = scope && scope.querySelector('[data-wishlist-toggle]');
      if (heart) {
        var own = read();
        if (has(own, heart.dataset.handle) === -1) {
          own.unshift({
            handle: heart.dataset.handle,
            title: heart.dataset.title,
            url: heart.dataset.url,
            image: heart.dataset.image,
            sku: heart.dataset.sku || '',
            id: heart.dataset.id || ''
          });
        }
        try { localStorage.setItem(KEY, JSON.stringify(own)); } catch (e) {}
        // leaveShared() clears any shared-link view and redraws the buyer's own list.
        leaveShared();
      }
      var openMenu = purchase.closest('dialog[open]');
      if (openMenu) openMenu.close();
      openDrawer();
      return;
    }
    var toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      var items = read();
      var index = has(items, toggle.dataset.handle);
      if (index > -1) {
        items.splice(index, 1);
      } else {
        items.unshift({
          handle: toggle.dataset.handle,
          title: toggle.dataset.title,
          url: toggle.dataset.url,
          image: toggle.dataset.image,
          sku: toggle.dataset.sku || '',
          id: toggle.dataset.id || ''
        });
      }
      write(items);
      return;
    }
    if (event.target.closest('[data-wishlist-whatsapp]')) {
      // Country, state and city are required before the wishlist goes to WhatsApp.
      var missing = firstMissingLocation();
      if (missing) {
        event.preventDefault();
        var lr = root();
        setStatus((lr && lr.dataset.locationRequired) || '');
        missing.focus();
        return;
      }
      setStatus('');
    }
    if (event.target.closest('[data-wishlist-share-link]')) {
      event.preventDefault();
      shareLink();
      return;
    }
    if (event.target.closest('[data-wishlist-save-all]')) {
      event.preventDefault();
      if (shared && shared.length) {
        var own = read();
        shared.slice().reverse().forEach(function (item) {
          if (has(own, item.handle) === -1) own.unshift(item);
        });
        shared = null;
        leaveShared();
        write(own);
      }
      return;
    }
    if (event.target.closest('[data-wishlist-view-mine]')) {
      event.preventDefault();
      leaveShared();
      return;
    }
    var opener = event.target.closest('[data-wishlist-open]');
    if (opener) {
      var drawer = document.getElementById('wishlist-drawer');
      if (!drawer) return;
      event.preventDefault();
      var current = opener.closest('dialog[open]');
      if (current && current !== drawer) current.close();
      if (!drawer.open) drawer.showModal();
    }
  });

  // Save each location choice, keep the lists linked, and refresh the WhatsApp message.
  function onLocationChange(event) {
    var picker = event.target.closest && event.target.closest('[data-wishlist-city-select]');
    if (picker) {
      if (event.type !== 'change') return;
      var cityBox = locField('city');
      if (!cityBox) return;
      var other = picker.value === '__other';
      showCityBox(other);
      cityBox.value = other ? '' : picker.value;
      updateLocation(cityBox);
      setStatus('');
      syncShare(read());
      if (other) cityBox.focus();
      return;
    }
    var input = event.target.closest && event.target.closest('[data-wishlist-loc]');
    if (!input) return;
    if (event.type === 'change' && input.tagName !== 'SELECT') return;
    if (event.type === 'input' && input.tagName === 'SELECT') return;
    updateLocation(input);
    setStatus('');
    syncShare(read());
  }
  document.addEventListener('input', onLocationChange);
  document.addEventListener('change', onLocationChange);

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) sync();
  });

  // Product grids are re-rendered when filters or sort change; keep their hearts in sync.
  var pending = false;
  new MutationObserver(function () {
    if (syncing || pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      syncButtons(read());
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); loadShared(); fillIds(); });
  } else {
    sync();
    loadShared();
    fillIds();
  }
})();
